export default {
    "type": "object",
    "required": [ 'name', 'email', 'usertype', 'status' ],
    "properties": {
        "profile_photo_path": {
            "type": "string",
            "default": "",
            "title": "Photo",
            "x-cols": "12",
        },
        "name": {
            "type": "string",
            "default": "",
            "title": "Name",
            "x-cols": "3",
            "x-class": "pr-2",
        },
        "email": {
            "type": "string",
            "default": "",
            "title": "Email",
            "x-cols": "3",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 255
            }
        },
        "password": {
            "type": "string",
            "default": "",
            "title": "Password",
            "x-cols": "3",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false
            }
        },
        "icno": {
            "type": "string",
            "default": "",
            "title": "QID No.",
            "x-cols": "3",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 7
            }
        },
        "contactno": {
            "type": "string",
            "default": "",
            "title": "Contact No.",
            "x-cols": "3",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 20
            }
        },
        "usertype": {
            "type": "string",
            "default": "operators",
            "title": "Account Type",
            "x-cols": "3",
            "x-class": "pr-2",
            "oneOf": [
                { "const": "operators", "title": "Operator" },
            ],
            "x-props": {
                "readonly": true
            }
        },
        "status": {
            "type": "string",
            "default": "01",
            "title": "Account Status",
            "x-cols": "3",
            "x-class": "pr-2",
            "oneOf": [
                { "const": "01", "title": "Active" },
                { "const": "02", "title": "Disabled" },
            ],
            "x-props": {
                "readonly": true
            }
        }
    }
}
